import React from "react";

export const WaterRepellentCarGlass = () => {
  return (
    <div>
      <div>
        <p className="mt-2 mb-2 font-bold">Glass Water Repellent Coating</p>
        <ul className="list-disc text-black-500">
          <li>Hydrophobic coating on all glass</li>
          <li>Improves rain visibility</li>
          <li>Repels dirt and dust</li>
          <li>Reduces wiper usage</li>
          <li>Protects from UV & stains</li>
          <li>Lasts up to 3 months</li>
        </ul>
      </div>
    </div>
  );
};

export default WaterRepellentCarGlass;
